'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const StandardTileSwatches = renderWithRef('StandardTileSwatches', null, (a, t)=>jsx(RenderComp, {
        root: "div",
        forwardedRef: t,
        classNames: [
            'swan-standard-tile-swatches'
        ],
        props: a,
        children: a.children
    }));

export { StandardTileSwatches };
